module.exports = __webpack_public_path__ + "static/media/paste3.5392b01f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/paste3.svg
// module id = 3286
// module chunks = 7